import {QueryFunctionContext, UseQueryOptions, useQuery} from '@tanstack/react-query'
import {fetchResponse} from './utils'

const KEY = 'userAccountBalance'

export const useAccountBalance = (userId: number | undefined): any => {
  return useQuery<any, Error>(
    [KEY, userId],
    async ({queryKey}: QueryFunctionContext): Promise<UseQueryOptions> => {
      return fetchResponse(`/v1/users/${queryKey[1]}/account-balance`)
    },
    {
      enabled: !!userId,
    },
  )
}
